var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}}):_c('div',[_c('div',{staticClass:"cardBox"},_vm._l((_vm.widgets),function(w){return _c('div',{key:w.id},[_c('Card',{attrs:{"type":w.template.is_multiple ? 'sumCardBox' : 'listCardBox',"cards":w.user_widgets}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-327df6d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = null
// module chunks = 